import React, { useState, useContext } from 'react';
import { Form, Button, ModalManagerContext, Input, Flex, Switch, Grid } from '@pega/cosmos-react-core';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { appState } from '../../../../interfaces/common';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';

interface AddChatProps {
  addProactiveChatRecord: any;
}

interface AddChatFormData {
  proactiveTrigger: string;
  displayName: string;
  botCommand: string;
  isEnabled: boolean;
}

const AddProactiveChat: React.FC<AddChatProps> = (props) => {
  const translate = useLocalTranslation();
  const { addProactiveChatRecord } = props;
  const { ModalContext } = useContext(ModalManagerContext);
  const { dismiss } = useContext(ModalContext);

  const [enabled, setEnabled] = useState(true);
  const { proactiveTriggers = [] } = useSelector((state: appState) => state.chatInfo);

  const { register, handleSubmit, errors, formState } = useForm<AddChatFormData>({
    mode: 'all',
    defaultValues: {
      proactiveTrigger: '',
      displayName: '',
      botCommand: '',
      isEnabled: true,
    },
  });

  const addRecord = ({ proactiveTrigger, displayName, botCommand, isEnabled }: AddChatFormData) => {
    if (formState.isValid) {
      addProactiveChatRecord(proactiveTrigger, displayName, botCommand, enabled);
    }
  };

  const handleOnSubmit = () => {
    handleSubmit(addRecord)();
    dismiss();
  };

  const isExistingCode = (inputVal: any) => {
    const isExistingCode = proactiveTriggers.filter((item) => {
      return item.code === inputVal;
    });

    if (isExistingCode && isExistingCode.length > 0) return true;
    else return false;
  };

  const actions = (
    <>
      <Button onClick={dismiss}>{translate('cancel')}</Button>
      <Button variant="primary" onClick={handleOnSubmit} disabled={!formState.isValid}>
        {translate('add')}
      </Button>
    </>
  );

  return (
    <Form actions={actions}>
      <Flex
        container={{
          direction: 'column',
          itemGap: 1,
        }}
      >
        <Input
          name="proactiveTrigger"
          label={translate('proactive_trigger')}
          type="text"
          required={true}
          autoComplete="off"
          info={errors.proactiveTrigger?.message}
          status={errors.proactiveTrigger?.message ? 'error' : undefined}
          ref={register({
            required: translate('code_empty'),
            pattern: { value: /^[0-9a-zA-Z_\b]+$/, message: translate('proactive_trigger_criteria_error') },
            validate: {
              isExistingCode: (v) => isExistingCode(v) === false || translate('proactive_trigger_criteria_error_1'),
            },
          })}
        />

        <Input
          name="displayName"
          label={translate('display_name')}
          type="text"
          required={true}
          autoComplete="off"
          info={errors.displayName?.message}
          status={errors.displayName?.message ? 'error' : undefined}
          ref={register({ required: translate('name_empty') })}
        />

        <Input
          name="botCommand"
          label={translate('bot_command')}
          type="text"
          required={true}
          autoComplete="off"
          info={errors.botCommand?.message}
          status={errors.botCommand?.message ? 'error' : undefined}
          ref={register({ required: translate('command_empty') })}
        />
        <Grid
          container={{
            cols: 'repeat(2, 18% 60%)',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Switch
            id="enable_switch"
            label={translate('enabled')}
            name="isEnable"
            ref={register()}
            onChange={() => setEnabled((enabled) => !enabled)}
            on={enabled}
          />
        </Grid>
        {/* <CheckboxGroup name="isEnabled">
          <Checkbox label="Enable" ref={register()} />
        </CheckboxGroup> */}
      </Flex>
    </Form>
  );
};
export default AddProactiveChat;
